// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--6D8n+";
export var hero__heading = "hero-module--hero__heading--e8PuP";